import { FC } from "react";
import { IVDPBlockData, IVDPPageBlock, VDPBlockPosition } from "../../../../types/vdp";
import EVSavingsBadgeClient from "./ev-range-map-client";
import { useIsMobile } from "@/utils/useIsMobile";

type WidgetConfig = {
  domain: string;
  mapId: string;
};

const EVRangeMap: FC<IVDPPageBlock> = ({ vdpGlobalData, pageContext, config }) => {
  const widgetConfig: WidgetConfig = config;
  const isDesktop = !useIsMobile(1280, pageContext.isSmartphone);

  return (
    <EVSavingsBadgeClient
      vin={vdpGlobalData.vehicle.vin}
      domain={widgetConfig.domain}
      mapId={widgetConfig.mapId}
      isDesktop={isDesktop}
    ></EVSavingsBadgeClient>
  );
};

const VDPBlockData: IVDPBlockData = {
  component: (props: IVDPPageBlock, key: any) => (
    <EVRangeMap
      key={key}
      config={props.config}
      siteData={props.siteData}
      pageContext={props.pageContext}
      renderingPosition={props.renderingPosition}
      vdpGlobalData={props.vdpGlobalData}
      translations={props.translations}
    />
  ),
  position: VDPBlockPosition.LEFT,
};

export default VDPBlockData;
